import { createSetter } from '@/store/vuexUtils'
import { forget, load, persist } from '@/utils/utils'
import { AuthApiService } from '@/services/api/AuthApiService'

const state = {
  token: load('AUTH_TOKEN')
}

const getters = {
  isLoggedIn (state) {
    return !!state.token
  }
}

const mutations = {
  STORE_TOKEN: createSetter('token'),
  CLEAR_TOKEN: createSetter('token', null)
}

const actions = {
  async login ({ commit, dispatch }, form) {
    const { token, user } = await AuthApiService.login(form)
    return dispatch('storeLoggedUserAndToken', { token, user })
  },

  storeLoggedUserAndToken ({ commit, dispatch }, { user, token }) {
    persist('AUTH_TOKEN', token)
    commit('STORE_TOKEN', token)
    return dispatch('user/storeUser', user, { root: true })
  },

  async logout ({ commit }, { skipRequest = false } = {}) {
    !skipRequest && await AuthApiService.logout()
    commit('CLEAR_TOKEN')
    forget('AUTH_TOKEN')
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
